import axios from "axios"
const apiBaseUrl = process.env.REACT_APP_APIBASE_URL
let UserType = JSON.parse(localStorage.getItem("WWINGS_USER_TYPE"))

export const createInsuranceneedAPI = async payload => {
  try {
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(
      `${apiBaseUrl}/create-insurance-need`,
      payload,
      { headers }
    )
    return response
  } catch (error) {
    console.error("Error creating insurance need:", error)
    throw error
  }
}



export const getInsuranceneedAPI = async (payload) => {
  let apiToken = JSON.parse(localStorage.getItem("authUser"))
  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    Authorization: apiToken,
    Accept: "application/json",
    "Cache-Control": "no-cache",
  }

  return await axios.post(`${apiBaseUrl}/${payload.url ? payload.url : 'get-insurance-need'}`,
    payload,
    { headers }
  )
}


export const getincomeAPI = async () => {
  let apiToken = JSON.parse(localStorage.getItem("authUser"))

  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    Authorization: apiToken,
    Accept: "application/json",
    "Cache-Control": "no-cache",
  }

  return await axios.get(`${apiBaseUrl}/get-income-range`, {
    headers,
  })
}

// delete insurance need
export const deleteInsuranceneedAPI = async payload => {
  try {
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(
      `${apiBaseUrl}/delete-insurance-need`,
      payload,
      { headers }
    )
    return response
  } catch (error) {
    console.error("Error creating insurance need:", error)
    throw error
  }
}



// delete insurance need
export const UpdateInsuranceNeedAPI = async payload => {
  try {
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(
      `${apiBaseUrl}/update-insurance-need`,
      payload,
      { headers }
    )
    return response
  } catch (error) {
    console.error("Error Updating insurance need:", error)
    throw error
  }
}